export { TITLE, NAME_1, POSITION_1, BODY_1 } from './constants'
export type { TReviewsProps } from './types'
export { getReviewsData } from './api'
export { Line } from './components'
export * as images from './images'
